import type { ComponentProps } from 'react';

import { cn } from './cn';

/** Bloco de carregamento com shimmer (parado em prefers-reduced-motion). Decorativo para leitor. */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden
      data-slot="skeleton"
      className={cn(
        'animate-shimmer rounded-sm bg-[linear-gradient(90deg,var(--lume-bg-inset)_0%,var(--lume-bg-sunk)_50%,var(--lume-bg-inset)_100%)] bg-size-[200%_100%]',
        className,
      )}
      {...props}
    />
  );
}
